import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import { transformApiError } from "common/api/errors";
import Resource from "common/components/Resource";
import Panel from "common/components/Panel";
import Form from "./Form";
import actions from "./actions";
import UserLocation from "./Location";
import { PREFERRED_LANGS } from "common/constants";

const handleSubmit = (id) => async (values, form) => {
  const body = {
    email: values.email,
    first_name: values.firstName,
    last_name: values.lastName,
    phone: values.phone,
    access_level: values.accessLevel === "user" ? null : values.accessLevel,
    lang_pref: values.langPref,
  };

  if (values.password) {
    body.password = values.password;
  }

  try {
    await actions.update(id, body);
    form.setStatus({ success: true });
  } catch (error) {
    const apiError = transformApiError(error);
    if (apiError.empty()) {
      form.setErrors({ http: error.message });
    } else {
      form.setErrors(apiError.object());
    }
  }
  form.setSubmitting(false);
};

const Edit = ({ match }) => (
  <Resource
    name="users"
    resourceId={match.params.id}
    render={(user) => (
      <Grid container direction="row">
        <Grid size={{ xs: 8 }}>
          <Panel title="User Details">
            <Form
              isEdit
              handleSubmit={handleSubmit(match.params.id)}
              initialValues={{
                email: user.email || "",
                phone: user.phone || "",
                firstName: user.first_name || "",
                lastName: user.last_name || "",
                accessLevel:
                  user.access_level === null ? "user" : user.access_level,
                langPref: user.lang_pref || PREFERRED_LANGS[0].value,
              }}
            />
          </Panel>
        </Grid>
        <Grid size={{ xs: 4 }}>
          <UserLocation user={user} />
        </Grid>
      </Grid>
    )}
  />
);

Edit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Edit;
